import React, { useState } from 'react';

const OrderLookup = () => {
  const [orderId, setOrderId] = useState('');
  const [order, setOrder] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const lookup = async (e) => {
    e.preventDefault();
    if (!orderId.trim()) return;
    setLoading(true);
    setError('');
    setOrder(null);
    try {
      const res = await fetch(`/api/order-lookup/${orderId.trim()}`);
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Order not found');
      setOrder(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const statusColor = (s) => {
    if (s === 'confirmed' || s === 'completed') return 'var(--accent)';
    if (s === 'failed' || s === 'expired') return 'var(--red-primary)';
    if (s === 'processing') return '#818cf8';
    return 'var(--orb-orange)';
  };

  return (
    <div className="auth-page">
      <div className="auth-card" style={{maxWidth:'460px'}}>
        <div className="auth-header">
          <div className="auth-logo">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
          </div>
          <span className="auth-brand">Outsourced</span>
        </div>
        
        <h1 className="auth-title">Track Order</h1>
        <p className="auth-accent-text">check your order status</p>
        <p className="auth-subtitle">Enter your order ID to see the current status</p>

        <form onSubmit={lookup}>
          <div className="auth-field">
            <label>Order ID</label>
            <input type="text" value={orderId} onChange={e => setOrderId(e.target.value)} placeholder="Paste your order ID here..." required />
          </div>
          <button type="submit" className="auth-submit" disabled={loading}>
            {loading ? 'Looking up...' : 'Track Order'}
          </button>
        </form>

        {error && <div className="auth-error" style={{marginTop:'1rem'}}>{error}</div>}

        {order && (
          <div style={{marginTop:'1.2rem',background:'rgba(255,255,255,0.02)',border:'1px solid rgba(255,255,255,0.06)',borderRadius:'10px',padding:'1rem'}}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'0.6rem'}}>
              <span style={{fontSize:'0.7rem',color:'var(--text-muted)'}}>Order ID</span>
              <code style={{fontSize:'0.68rem',background:'rgba(0,0,0,0.3)',padding:'2px 6px',borderRadius:'4px',wordBreak:'break-all'}}>{order.id}</code>
            </div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'0.6rem'}}>
              <div>
                <div style={{fontSize:'0.65rem',color:'var(--text-muted)',marginBottom:'0.15rem'}}>Product</div>
                <div style={{fontSize:'0.8rem'}}>{order.isTopup ? 'Balance Top Up' : `${order.quantity}x ${order.productName}`}</div>
              </div>
              <div>
                <div style={{fontSize:'0.65rem',color:'var(--text-muted)',marginBottom:'0.15rem'}}>Total</div>
                <div style={{fontSize:'0.8rem',color:'var(--accent)',fontWeight:600}}>${(order.total||0).toFixed(2)}</div>
              </div>
              <div>
                <div style={{fontSize:'0.65rem',color:'var(--text-muted)',marginBottom:'0.15rem'}}>Payment</div>
                <div style={{fontSize:'0.8rem',color:statusColor(order.status),fontWeight:500}}>{order.status}</div>
              </div>
              <div>
                <div style={{fontSize:'0.65rem',color:'var(--text-muted)',marginBottom:'0.15rem'}}>{order.isTopup ? 'Top Up' : 'Boosts'}</div>
                <div style={{fontSize:'0.8rem',color:statusColor(order.boostStatus),fontWeight:500}}>{order.boostStatus}</div>
              </div>
              <div>
                <div style={{fontSize:'0.65rem',color:'var(--text-muted)',marginBottom:'0.15rem'}}>Email</div>
                <div style={{fontSize:'0.8rem'}}>{order.email}</div>
              </div>
              <div>
                <div style={{fontSize:'0.65rem',color:'var(--text-muted)',marginBottom:'0.15rem'}}>Date</div>
                <div style={{fontSize:'0.8rem'}}>{order.createdAt ? new Date(order.createdAt).toLocaleString() : '—'}</div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default OrderLookup;
